import { GenericTable } from "@shared/components/GenericTable";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@shared/ui/dialog";

interface TableModalProps {
  isOpen: boolean;
  title: string;
  onClose: () => void;
  columns: any[];
  data: any[];
  loading?: boolean;
  searchPlaceholder?: string;
  onSearch?: (value: string) => void;
  pagination?: any;
  onPageChange?: (page: number) => void;
  filterPanel?: React.ReactNode;
  actions?: any[];
}

export const TableModal: React.FC<TableModalProps> = ({
  isOpen,
  title,
  onClose,
  columns,
  data,
  loading,
  searchPlaceholder,
  onSearch,
  pagination,
  onPageChange,
  filterPanel,
  actions,
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-6xl w-full p-0 max-h-[90vh] overflow-hidden">
        <DialogHeader className="p-4 border-b">
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>

        {/* Scrollable wrapper */}
        <div className="p-4 max-h-[80vh] overflow-y-auto overflow-x-auto">
          <GenericTable
            data={data}
            columns={columns}
            rowKey="id"
            loading={loading}
            searchPlaceholder={searchPlaceholder}
            onSearch={onSearch}
            pagination={pagination}
            onPageChange={onPageChange}
            filterPanel={filterPanel}
            actions={actions}
            actionsType="dropdown"
            emptyMessage="No records found"
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};
